import styled, { css } from 'styled-components';
import { Form } from 'formik';
import { LEFT_BORDER_CLASS } from './constants';

export const StyledForm = styled(Form)<{
  $isMobile: boolean;
  $isWizardOpen: boolean;
  $isWizard?: boolean;
  $variant?: 'default' | 'hotel';
  $searchType?: string;
}>`
  ${({ $isMobile }) => !$isMobile && `position: relative`};
  z-index: 3;
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  ${({ $isWizard }) => !$isWizard && `align-items: center`};
  width: 100%;
  height: auto;
  ${({ $variant }) => ($variant !== 'hotel' ? 'margin: 0 auto;' : '')}
  background-color: ${({ $isMobile, $isWizard }) => ($isMobile && !$isWizard ? '#4D4D4D' : '#fff')};
  border-radius: 4px;
  gap: ${({ $isMobile, $isWizard }) => ($isMobile && !$isWizard ? '8px' : '0')};

  ${({ $isMobile, $isWizard }) => $isMobile && !$isWizard && 'padding: 8px;'};

  ${({ $isWizardOpen }) =>
    $isWizardOpen &&
    css`
      align-items: flex-start;
      position: fixed;
      top: 0;
    `}

  ${({ $isMobile }) =>
    !$isMobile &&
    css`
      .${LEFT_BORDER_CLASS} + .${LEFT_BORDER_CLASS} {
        ${leftBorder}
      }
    `}

    ${({ $searchType, $variant, $isMobile }) =>
    $variant === 'hotel' &&
    !$isMobile &&
    css`
      .cigarette__field-border #start {
        border-radius: 4px;
      }
      > .cigarette__field-border {
        width: ${$searchType === 'hotel' ? '400' : '300'}px !important;
        max-width: ${$searchType === 'hotel' ? '400' : '300'}px !important;
      }
      > :first-child {
        width: ${$searchType === 'hotel' ? '800' : '600'}px !important;
      }
    `}
`;

export const mobileDefaultControlStyles = css`
  border: 1px solid #17181a;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  height: 48px;
  border-radius: 4px;
  padding: 8px;
`;

export const mobileHotelPageControlStyles = css`
  border: 1px solid #c2c5cc;
`;

export const MobileLabel = styled.span<{ $variant?: 'default' | 'hotel' }>`
  color: ${({ $variant }) => ($variant === 'hotel' ? '#4D4D4D' : '#c2c5cc')};
  text-transform: uppercase;
  font-size: 9px;
  line-height: 12px;
  letter-spacing: 0.1em;
  align-self: start;
  font-weight: normal;
`;

export const leftBorder = css`
  &:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 40px;
    background-color: #e6e9ee;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
  }
`;

export const mobileWidgetInputStyles = css`
  input {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transform: none;
  }
`;
